import { createFileRoute } from "@tanstack/react-router";
import MyExamination from "../../app/views/competence/myExamination";

export const Route = createFileRoute("/competence/myExamination")({
  component: MyExamination,
});
